module.exports = __webpack_public_path__ + "img/logo.7bb49516.png";